class NavAccordionGroup {
  constructor () {
    this.setupListeners()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    const triggers = document.querySelectorAll(
      '[data-nav-accordion-group-el="trigger"]',
    )
    triggers.forEach((triggerEl) => {
      triggerEl.addEventListener(`click`, this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const itemEl = event.target.closest('[data-nav-accordion-group-el="item"]')
    if (!itemEl) return

    const groupEl = event.target.closest('nav-accordion-group')
    const itemEls = document.querySelectorAll(
      '[data-nav-accordion-group-el="item"]',
    )

    if (groupEl.dataset.type === 'oneopen') {
      itemEls.forEach((tempEl) => {
        if (tempEl !== itemEl) {
          tempEl.setAttribute('aria-expanded', 'false')
        }
      })
    }

    const currentState = itemEl.getAttribute('aria-expanded') === 'true'
    itemEl.setAttribute('aria-expanded', !currentState)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-new
  new NavAccordionGroup()
})
